export default {"src":"/_next/static/image/public/images/ic_no_border_video.90cb35e2df160830ecb02c02d351168b.svg","height":15,"width":22};